import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './Navbar';
import { authenticationService } from '../services/auth.service';
import { useEffect, useState } from 'react';
import { AuthProvider } from './auth/AuthContext';
import Login from '../pages/login/Login';
import NewPassword from '../pages/new-password/NewPassword';
import Home from '../pages/home/Home';
import ProtectedRoute from './auth/ProtectedRoute';
import MemberCredentialRequestList from '../pages/member/member-credential-request-list/MemberCredentialRequestList';
import MemberBaptismList from '../pages/member/member-baptism-list/MemberBaptismList';
import NotFound from '../pages/not-found/NotFound';
import MemberDeletedList from '../pages/member/member-deleted-list/MemberDeletedList';
import MemberAddEdit from '../pages/member/member-add-edit/MemberAddEdit';
import MemberList from '../pages/member/member-list/MemberList';
import AnnuityList from '../pages/secretary/annuity-list/AnnuityList';
import DashboardSecretary from '../pages/dashboard-secretary/DashboardSecretary';
import CongregationAddEdit from '../pages/congregation/congregation-add-edit/CongregationAddEdit';
import CongregationList from '../pages/congregation/congregation-list/CongregationList';
import EventPersonEdit from '../pages/event-person/event-person-edit/EventPersonEdit';
import EventPersonList from '../pages/event-person/event-person-list/EventPersonList';
import EventPrintList from '../pages/event-person/event-print-list/EventPrintList';
import EventRunning from '../pages/event-person/event-running/EventRunning';
import DashboardEvent from '../pages/event-person/dashboard-event/DashboardEvent';
import UserList from '../pages/user/user-list/UserList';
import MeetingMemberList from '../pages/meeting/meeting-member-list/MeetingMemberList';
import MeetingAdd from '../pages/meeting/meeting-add/MeetingAdd';
import MeetingRunning from '../pages/meeting/meeting-running/MeetingRunning';
import MeetingList from '../pages/meeting/meeting-list/MeetingList';
import MeetingEdit from '../pages/meeting/meeting-edit/MeetingEdit';
import ScheduleCalendar from '../pages/schedule/schedule-calendar/ScheduleCalendar';
import LetterList from '../pages/secretary/letter-list/LetterList';
import AuditList from '../pages/user/audit-list/AuditList';
import MeetingSignature from '../pages/meeting/meeting-signature/MeetingSignature';
import DashboardUmadeub from '../pages/umadeub/dashboard-umadeub/DashboardUmadeub';
import YouthPersonList from '../pages/umadeub/youth-person-list/YouthPersonList';
import YouthPersonAddEdit from '../pages/umadeub/youth-person-add-edit/YouthPersonAddEdit';
import CampaignPersonList from '../pages/campaign/campaign-person-list/CampaignPersonList';
import CampaignPersonAddEdit from '../pages/campaign/campaign-person-add-edit/CampaignPersonAddEdit';
import DashboardCampaign from '../pages/campaign/dashboard-campaign/DashboardCampaign';
import Unauthorized from '../pages/unauthorized/Unauthorized';
import { UserRoleEnum } from '../models/enums/UserRoleEnum';
import CampaignPaymentList from '../pages/campaign/campaign-payment-list/CampaignPaymentList';
import CampaignTransactionHistory from '../pages/campaign/campaign-transaction-history/CampaignTransactionHistory';
import ProtocolList from '../pages/secretary/protocol/protocol-list/ProtocolList';
import OrderList from '../pages/order/order-list/OrderList';
import OrderEdit from '../pages/order/order-edit/OrderEdit';
import JobSkipList from '../pages/configuration/job/job-skip-list/JobSkipList';
import OrderSummary from '../pages/order/order-summary/OrderSummary';
import OrderLotList from '../pages/order-lot/order-lot-list/OrderLotList';
import MemberBaptizedReport from '../pages/member/member-baptized-report/MemberBaptizedReport';
import EventList from '../pages/event-person/event-list/EventList';
import EventAddEdit from '../pages/event-person/event-add-edit/EventAddEdit';
import MemberAbsenceList from '../pages/member/member-absence-list/MemberAbsenceList';
import CouponPersonList from '../pages/coupon/coupon-person-list/CouponPersonList';
import PresencePersonList from '../pages/presence/presence-person-list/PresencePersonList';
import { getRouterBasename } from '../utils/slug';

function RoutesComponent() {
    const [userLogged, setUserLogged] = useState(false);
    const basename = getRouterBasename();

    useEffect(()=> {
        authenticationService.currentUser.subscribe(value => {
            setUserLogged(value != null);
        });
    }, []);

    return (
        <AuthProvider>
            <Router basename={basename}>
                <div className={userLogged ? 'uk-offcanvas-content': ''}>
                    { userLogged && <Navbar></Navbar> }
                    <div className={userLogged ? 'uk-container': ''}>
                        <Routes>
                        <Route path="/entrar" element={<Login />} />
                        <Route path="/nova-senha" element={<NewPassword />} />
                        <Route path="/" element={<Home />} />
                        <Route element={<ProtectedRoute allowedRoles={[UserRoleEnum.ALWAYS_ALLOWED]} />}>
                            <Route path="/inicio" element={<Home />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessSecretaryRoles()} />}>
                            <Route path="/membros/credenciais-solicitadas" element={<MemberCredentialRequestList />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessSecretaryRoles()} />}>
                            <Route path="/membros/batismo/lista" element={<MemberBaptismList />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessSecretaryRoles()} />}>
                            <Route path="/membros/removidos" element={<MemberDeletedList />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessMembersRoles()} />}>
                            <Route path="/membros/novo" element={<MemberAddEdit />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessMembersRoles()} />}>
                            <Route path="/membros/:id" element={<MemberAddEdit />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessMembersRoles()} />}>
                            <Route path="/membros" element={<MemberList />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessSecretaryRoles()}/>}>
                            <Route path="/secretaria/anuidades" element={<AnnuityList />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessSecretaryRoles()}/>}>
                            <Route path="/secretaria/cartas" element={<LetterList />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessSecretaryRoles('protocol')}/>}>
                            <Route path="/secretaria/protocolos" element={<ProtocolList />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessSecretaryRoles()}/>}>
                            <Route path="/secretaria" element={<DashboardSecretary />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessAdminRoles('congregation')}/>}>
                            <Route path="/sistema/congregacoes/novo" element={<CongregationAddEdit />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessAdminRoles('congregation')}/>}>
                            <Route path="/sistema/congregacoes/:id" element={<CongregationAddEdit />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessAdminRoles('congregation')}/>}>
                            <Route path="/sistema/congregacoes" element={<CongregationList />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessAdminRoles('routine')}/>}>
                            <Route path="/sistema/jobs" element={<JobSkipList />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessSecretaryRoles()} />}>
                            <Route path="/secretaria/batismos" element={<MemberBaptizedReport />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessSecretaryRoles()} />}>
                            <Route path="/secretaria/faltas-reuniao" element={<MemberAbsenceList />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessEventRoles()}/>}>
                            <Route path="/eventos/:idEvent/pessoas/:id" element={<EventPersonEdit />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessEventRoles()}/>}>
                            <Route path="/eventos/:id/pessoas" element={<EventPersonList />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessEventRoles()}/>}> 
                            <Route path="/eventos/:idEvent/presencas/:idPresence/pessoas" element={<PresencePersonList />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessEventRoles()}/>}>
                            <Route path="/eventos/:id/impressoes" element={<EventPrintList />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessEventRoles()}/>}>
                            <Route path="/eventos/:id/em-andamento" element={<EventRunning />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessEventRoles()}/>}>
                            <Route path="/eventos/lista" element={<EventList />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessEventRoles()}/>}>
                            <Route path="/eventos/novo" element={<EventAddEdit />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessEventRoles()}/>}>
                            <Route path="/eventos/:id" element={<EventAddEdit />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessEventRoles()}/>}>
                            <Route path="/eventos/" element={<DashboardEvent />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessEventRoles()}/>}>
                            <Route path="/eventos/:id/dashboard" element={<DashboardEvent />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessAdminRoles()}/>}>
                            <Route path="/sistema/usuarios" element={<UserList />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessSecretaryRoles('meeting')}/>}>
                            <Route path="/reuniao/:id/membros" element={<MeetingMemberList />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessSecretaryRoles('meeting')}/>}>
                            <Route path="/reuniao/:id/assinatura/:idUser" element={<MeetingSignature />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessSecretaryRoles('meeting')}/>}>
                            <Route path="/reuniao/nova" element={<MeetingAdd />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessRoutinesRoles('meeting')}/>}>
                            <Route path="/reuniao/em-andamento" element={<MeetingRunning />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessSecretaryRoles('meeting')}/>}>
                            <Route path="/reuniao/lista" element={<MeetingList />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessSecretaryRoles('meeting')}/>}>
                            <Route path="/reuniao/:id" element={<MeetingEdit />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessSecretaryRoles('schedule')}/>}>
                            <Route path="/calendario" element={<ScheduleCalendar />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessAdminRoles()}/>}>
                            <Route path="/auditoria" element={<AuditList />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessYouthRoles()}/>}>
                            <Route path="/umadeub" element={<DashboardUmadeub />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessYouthRoles()}/>}>
                            <Route path="/jovens" element={<YouthPersonList />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessYouthRoles()}/>}>
                            <Route path="/jovens/novo" element={<YouthPersonAddEdit />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessYouthRoles()}/>}>
                            <Route path="/jovens/:id" element={<YouthPersonAddEdit />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessFinanceRoles('campaign')}/>}>
                            <Route path="/campanhas" element={<DashboardCampaign />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessCampaignRoles()}/>}>
                            <Route path="/campanhas/pessoas" element={<CampaignPersonList />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessFinanceRoles('campaign')}/>}>
                            <Route path="/campanhas/pagamentos" element={<CampaignPaymentList />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessCampaignRoles()}/>}>
                            <Route path="/campanhas/pessoas/novo" element={<CampaignPersonAddEdit />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessCampaignRoles()}/>}>
                            <Route path="/campanhas/pessoas/:id" element={<CampaignPersonAddEdit />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessAdminYouthRoles('store')}/>}>
                            <Route path="/pedidos/:type" element={<OrderList />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessAdminYouthRoles('store')}/>}>
                            <Route path="/pedidos/:type/:id" element={<OrderEdit />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessAdminYouthRoles('store')}/>}>
                            <Route path="/pedidos/:type/resumo" element={<OrderSummary />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessAdminYouthRoles('store')}/>}>
                            <Route path="/pedidos/:type/lotes" element={<OrderLotList />} />
                        </Route>
                        <Route element={<ProtectedRoute allowedRoles={authenticationService.accessFinanceRoles()}/>}>
                            <Route path="/cupons/:id/pessoas" element={<CouponPersonList />} />
                        </Route>
                        <Route path="/meu-extrato/:token" element={<CampaignTransactionHistory />} />
                        <Route path="/nao-autorizado" element={<Unauthorized />} />
                        <Route path="*" element={<NotFound />} />
                        </Routes>
                    </div>
                </div>
            </Router>
        </AuthProvider>
    );
}

export default RoutesComponent;